import { formatPriceValue as baseFormatPriceValue } from './format';

const VIEW_ITEM_LIST_EVENT = 'view_item_list';
const SELECT_ITEM_LIST_EVENT = 'select_item';
const VIEW_ITEM_EVENT = 'view_item';
const ADD_TO_CART_EVENT = 'add_to_cart';
const VIEW_CART_EVENT = 'view_cart';
const BEGIN_CHECKOUT_EVENT = 'begin_checkout';
const ADD_SHIPPING_INFO = 'add_shipping_info';
const ADD_PAYMENT_INFO = 'add_payment_info';
const PURCHASE = 'purchase';

/**
 * Override the base formatPriceValue function to use the 'number' data type by default.
 * 
 * @param {*} value 
 */
function formatPriceValue(value) {
  return baseFormatPriceValue(value, 'number');  
}

/**
 * Tracks Google Ecommerce event for a product.
 * @param {*} params
 */
const trackEcommerceEvent = (eventName, params) => {
  try {
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    // @ts-ignore
    dataLayer.push({     // eslint-disable-line no-undef
      event: eventName, 
      ecommerce: {...params }, 
    });
  } catch (error) {
    // Avoid crashing the app if there is an error
    console.error('trackEcommerceEvent', error);
  }
};

function getCurrency() {
  return process.env.VUE_APP_REGION === 'US' ? 'USD' : 'AUD';
}

export {
  trackEcommerceEvent,
  getCurrency,
  formatPriceValue,

  // EVENT NAMES
  VIEW_ITEM_LIST_EVENT,
  SELECT_ITEM_LIST_EVENT,
  VIEW_ITEM_EVENT,
  ADD_TO_CART_EVENT,
  VIEW_CART_EVENT,
  BEGIN_CHECKOUT_EVENT,
  ADD_SHIPPING_INFO,
  ADD_PAYMENT_INFO,
  PURCHASE,
};